import React from 'react'
import classnames from 'classnames'

export interface IStatusChip {
  name: string | number | undefined
  type?: 'new' | 'pending' | 'processed' | 'error'
  size?: 'M' | 'L'
  dot?: boolean
  iconRight?: string
  onClose?: React.MouseEventHandler<HTMLButtonElement>
}

const StatusChip = ({ name, type = 'new', size = 'L', dot, onClose }: IStatusChip) => {
  return (
    <span
      className={classnames('inline-flex items-center rounded-3xl border px-3', {
        'border-main-blue text-main-blue': type === 'new',
        'border-yellow text-yellow': type === 'pending',
        'border-green text-green': type === 'processed',
        'border-red text-red': type === 'error',
      })}>
      {dot && (
        <span
          className={classnames('mr-2 h-2 w-2 rounded-full', {
            'bg-main-blue': type === 'new',
            'bg-yellow': type === 'pending',
            'bg-green': type === 'processed',
            'bg-red': type === 'error',
          })}></span>
      )}
      <span
        className={classnames('py-1 text-sm', {
          'leading-[8px]': size === 'M',
          'leading-[14px]': size === 'L',
        })}>
        {name}
      </span>
      {onClose && (
        <span
          onClick={onClose}
          className={classnames('icon-close ml-2 cursor-pointer text-sm', {
            'text-main-blue': type === 'new',
            'text-yellow': type === 'pending',
            'text-green': type === 'processed',
            'text-red': type === 'error',
          })}></span>
      )}
    </span>
  )
}

export default StatusChip
